import LegalPageEditor from './LegalPageEditor'

const SECTIONS = [{ id: 'main', label: 'SLE Content' }]

export default function SLECmsPage() {
    return (
        <LegalPageEditor
            page="sle"
            liveUrl={`${import.meta.env.VITE_FRONTEND_URL || 'https://tendercentrix.com'}/service-level-expectations`}
            pageTitle="Service Level Expectations — Content Editor"
            pageDescription="Edit the SLE page hero and content. Content is stored as HTML."
            sections={SECTIONS}
        />
    )
}
